import DrawCountdownString from 'components/token-town/draws/draw-countdown/DrawCountdown';
import styles from './EnterDrawCountdown.module.css';
import { useMemo } from 'react';

interface EnterDrawCountdownProps {
  date: string | null | undefined;
}

const EnterDrawCountdown = (props: EnterDrawCountdownProps) => {
  const date = useMemo(
    () => (props.date ? new Date(props.date) : undefined),
    [props.date],
  );
  return (
    <div className={styles.enterDrawCountdown}>
      <strong>Next draw in</strong>
      <span>
        {date ? (
          <DrawCountdownString
            date={date}
            initialValue="--- : --- : --- : ---"
          />
        ) : (
          '--- : --- : --- : ---'
        )}
      </span>
    </div>
  );
};

export default EnterDrawCountdown;
